<template>
    <page-container class="seal-manage"
                    v-loading="loaddingCurr || loaddingOther"
                    element-loading-text="加载中..."
                    :class="{ 'content': !hideNavigate}">
        <el-breadcrumb slot="header"
                       separator="/"
                       v-if="!hideNavigate">
            <el-breadcrumb-item :to="{ path: '/home' }"
                                replace>电子印章</el-breadcrumb-item>
            <el-breadcrumb-item>
                <a>印章管理</a>
            </el-breadcrumb-item>
        </el-breadcrumb>

        <div class="seal-manage-list">
            <div>
                <el-button class="grey-text small-font"
                           type="text"
                           v-if="!hideNavigate"
                           @click="$router.push('/home')">&lt; 返回上一页</el-button>

                <el-button v-if="sealSet[0].seals && sealSet[0].seals.length"
                           :class="{'fr' : !hideNavigate}"
                           @click="goCreate"
                           size="small">申请新的印章</el-button>
            </div>

            <!-- 当前印章 -->
            <current-ukey-seal></current-ukey-seal>

            <div class="sign-table"
                 v-for="(seals, key) in sealSet"
                 :key="key">
                <p class="small-font title">
                    {{seals.name}}
                    <template>
                        <el-select size="small"
                                   v-if="!seals.isCurrent"
                                   class="query-item"
                                   v-model="otherFilter.status">
                            <el-option :value="0"
                                       label="全部"></el-option>
                            <el-option v-for="item in 7"
                                       :key="item"
                                       :label="item | sealStatus"
                                       :value="item">
                            </el-option>
                        </el-select>
                        <el-select size="small"
                                   v-if="!seals.isCurrent"
                                   class="query-item"
                                   v-model="otherFilter.order">
                            <el-option value="ASC"
                                       label="时间正序"></el-option>
                            <el-option value="DESC"
                                       label="时间倒序"></el-option>
                        </el-select>
                    </template>
                </p>
                <template v-if="seals.seals.length">
                    <template v-if="seals.seals.length">
                        <div class="seal-content"
                             v-for="(seal, index) in seals.seals"
                             :key="index">
                            <div class="seal-image">
                                <img v-if="seal.sealKey"
                                     :src="`${BASE_APP_PATH}/seal/image?fileKey=${seal.sealKey}`"
                                     alt="">
                                <img v-else
                                     :src="`data:image/png;base64,${seal.picData}`"
                                     alt="">
                            </div>
                            <div class="seal-info">
                                <h4 class="title">{{seal.name || seal.sealDetail && seal.sealDetail.seal_name}}</h4>
                                <div class="small-font info-content">
                                    <p>
                                        <span class="label tip">持有者：</span>
                                        <span class="content-text">{{seal.ownerName}}</span>
                                    </p>
                                    <!-- 待审核 -->
                                    <template v-if="seal.status == 6">
                                        <p>
                                            <span class="label tip">申请时间：</span>
                                            <span class="content-text">{{seal.createTime}}</span>
                                        </p>
                                    </template>
                                    <!-- 否决 -->
                                    <template v-else-if="seal.status == 5">
                                        <p>
                                            <span class="label tip">否决原因：</span>
                                            <span class="content-text">{{seal.reason}}</span>
                                        </p>
                                    </template>
                                    <!-- 其他 -->
                                    <template v-else>
                                        <p>
                                            <span class="label tip">统一社会信用代码：</span>
                                            <span class="content-text"
                                                  v-if="seal">{{seal.creditcode || seal.sealDetail && seal.sealDetail.creditcode}}</span>
                                        </p>
                                        <p>
                                            <span class="label tip">有效期起始时间：</span>
                                            <span class="content-text">起{{seal.not_before || seal.sealDetail && seal.sealDetail.not_before}}-止{{seal.not_after || seal.sealDetail && seal.sealDetail.not_after}}</span>
                                        </p>
                                    </template>

                                </div>
                                <div v-if="seals.isCurrent && seal.id">
                                    <seal-control :seal="seal"
                                                  @onFlesh="doFleshData"></seal-control>
                                </div>
                            </div>
                            <div class="seal-status">
                                <svg class="icon"
                                     style="font-size:70px;"
                                     aria-hidden="true">
                                    <use :xlink:href="seal.status | statusFont"></use>
                                </svg>

                                <div class="ctrl-container"
                                     v-if="seals.isCurrent && seal.status != 6 && seal.id">
                                    <el-button type="text"
                                               @click="doGoView(seal.id)"><u>操作记录</u></el-button>
                                </div>
                            </div>
                        </div>
                    </template>

                    <el-pagination background
                                   class="pagination"
                                   v-if="!seals.isCurrent && seals.seals.length"
                                   layout="total, prev, pager, next"
                                   @current-change="handlePageChange"
                                   :page-size="3"
                                   :current-page="currPage"
                                   :total="otherDisplaySeals.length">
                    </el-pagination>
                </template>

                <div v-else-if="!seals.isCurrent"
                     class="text-center no-data">
                    <img src="../../assets/images/common/no-seal.png"
                         alt="">
                    <p class="tip">暂无相关数据</p>
                </div>

                <div v-else-if="seals.isCurrent"
                     class="text-center no-data">
                    <img src="../../assets/images/common/no-seal.png"
                         alt="">
                    <p class="tip">暂未在公共平台申请印章</p>
                    <el-button type="primary"
                               @click="goCreate"
                               size="medium">申请新的印章</el-button>
                </div>
            </div>

            <!-- 印章备案（2021.9.24取消印章备案） -->
            <!-- <seal-record></seal-record> -->
        </div>
    </page-container>
</template>
<script>
import PageContainer from "../../components/container.vue";
// 2021.9.24,取消印章备案功能
// import SealRecord from "./record.vue";
import SealControl from "./childs/seal-control.vue";
import CurrentUkeySeal from './current-ukey.vue';

export default {
    name: "Seal",
    components: {
        PageContainer,
        SealControl,
        CurrentUkeySeal
    },
    data () {
        return {
            otherSeals: [],
            otherFilter: {
                status: 0,
                order: 'ASC'
            },
            currPage: 1,
            orgCode: '',
            loaddingCurr: false,
            loaddingOther: false,
            sealSet: [{ seals: [], name: '最新印章', isCurrent: true }, { seals: [], name: '其他印章', isCurrent: false }]
        };
    },
    props: {
        hideNavigate: Boolean
    },
    computed: {
        isMac () {
            return this.$store.getters.isMac;
        },
        otherDisplaySeals () {
            let otherSeals = this.Utils.deepClone(this.otherSeals);
            const { status } = this.otherFilter;
            otherSeals = status ? otherSeals.filter(seal => seal.seal_status === status) : otherSeals;
            otherSeals = this.sortOperator(otherSeals);
            return otherSeals || [];
        }
    },
    inject: ['app'],
    filters: {
        className (status) {
            let result = '';
            switch (status) {
            case 1:
                result = 'green-text';
                break;
            case 2:
            case 3:
            case 4:
            case 5:
                result = 'red-text';
                break;
            case 6:
                result = 'blue-text';
                break;
            }
            return result;
        },
    },
    watch: {
        otherFilter: {
            handler () {
                this.currPage = 1;
                this.handlePageChange(this.currPage);
            },
            deep: true
        },
        'app.cert': {
            async  handler (nv) {
                if (nv) {
                    this.loaddingOther = true;
                    this.loaddingCurr = true;
                    await this.getTableData();
                    await this.getTableData(true);
                }
            },
            immediate: true
        },
        'app.picData': {
            async  handler (nv) {
                if (nv) {
                    this.loaddingCurr = true;
                    await this.getTableData(true);
                }
            },
            immediate: true
        }
    },
    methods: {

        doFleshData () {
            this.getTableData();
            this.getTableData(true);
        },

        /** 排序函数 */
        sortOperator (seals) {
            const { order } = this.otherFilter;
            let compare = (property) => {
                return (a, b) => {
                    const value1 = new Date(a[property]).getTime();
                    const value2 = new Date(b[property]).getTime();
                    return order === 'ASC' ? value1 - value2 : value2 - value1;
                };
            };
            return seals.sort(compare('not_before'));
        },

        formatOtherSeal(seals) {
            // creditcode: "91310120MA1HKGA66W"
            // not_after: "2019-12-06 00:06:23"
            // not_before: "2020-04-17 14:20:42"
            // pic_data: "iVBORw0KGgoAAAANSUhEUgAAAM8AAADPCAYAAABSgYVfAABJl0"
            // pic_height: "207"
            // pic_type: "png"
            // pic_width: "207"
            // seal_name: "测试ukey"
            // seal_sn: "62126845981412207724558894394905"
            // seal_status: 1
            // sign_alg: "SHA256withRSA"
            // user_name: "测试上海亘岩科技网络有限公司6"
            // verify: true
            // vid: "SHECA"

            const formatSeals = this.Utils.deepClone(seals);
            formatSeals.length = seals.length;
            formatSeals.map(seal => {
                this.$set(seal, 'picData', seal.pic_data);
                this.$set(seal, 'status', seal.seal_status);
                this.$set(seal, 'name', seal.seal_name);
                this.$set(seal, 'ownerName', seal.user_name);
            });
            return formatSeals;
        },

        // 获取表格数据
        async getTableData (isCurrent = false) {

            let url = isCurrent ? '/seal/list/current' : '/seal/list/other';
            let requsetData = new FormData();
            if (isCurrent) {
                requsetData.append('sealData', this.app.sealData);
                requsetData.append('old', this.app.isOld);
                requsetData.append('picData', this.app.picData);
            }

            requsetData.append('cert', this.app.cert);
            try {
                let res = await this.axios({
                    url: url,
                    method: "POST",
                    data: requsetData
                });
                if (res.data.code === 0) {
                    if (isCurrent) {
                        this.sealSet[0].seals = res.data.currentSeals || [];
                    } else {
                        this.otherSeals = res.data.otherSeals || [];
                        this.totalCount = this.otherSeals.length || 0;
                        let currPageSeals = this.Utils.deepClone(this.otherDisplaySeals);
                        if (this.totalCount > 3) {
                            currPageSeals.length = 3;
                        }
                        const otherSeals = this.formatOtherSeal(currPageSeals);
                        this.$set(this.sealSet[1], 'seals', otherSeals);
                    }
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.$nextTick(() => {
                    if (isCurrent) {
                        this.loaddingCurr = false;
                    } else {
                        this.loaddingOther = false;
                    }
                });
            }
        },

        /**
         * 翻页
         */
        handlePageChange (pageNo) {
            this.sealSet[1].seals = [];
            this.currPage = pageNo;
            let currPageSeals = this.Utils.deepClone(this.otherDisplaySeals);
            let result = [];
            let start = (pageNo - 1) * 3;
            let end = start + 3;
            if (end > currPageSeals.length) {
                end = currPageSeals.length;
            }
            for (start; start < end; start++) {
                result.push(currPageSeals[start]);
            }
            const otherSeals = this.formatOtherSeal(result);
            this.sealSet[1].seals = otherSeals;
        },

        goCreate () {
            this.$router.push({
                path: '/sealcreate',
                query: {
                    hideFrame: this.hideNavigate
                }
            });
        },

        /**
         * 查看详情
         */
        doGoView (id) {
            this.$router.push({
                path: `/seal/${id}`,
                query: { hideFrame: this.hideNavigate }
            });
        },
    },
    beforeDestroy () {
        clearInterval(this.timer);
    }
};
</script>
<style lang="less" scoped>
.seal-manage {
    padding: 15px;

    .seal-manage-list {
        padding: 20px;
        margin: 0 auto;
        .el-button--default {
            border: 1px solid @red;
            margin-bottom: 20px;
            color: @red;
        }
    }
    .black-text:hover {
        text-decoration: underline;
    }
    .clear {
        clear: both;
    }
    .query-item {
        width: 160px;
        margin-left: 16px;
    }
    .sign-table {
        margin-top: 20px;
        border-top: 1px solid @border-color-base;
        padding-top: 24px;
        .title {
            margin-bottom: 10px;
        }
    }
    .transform-center {
        img {
            margin-right: 20px;
        }
        span {
            display: block;
            flex: 1;
        }
    }

    .pagination {
        text-align: right;
        margin: 20px auto 0;
    }
}
</style>